module.exports = __webpack_public_path__ + "b0e5ed9d45b3a62f165847450368f691.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_3_sq.mp3
 ** module id = 176
 ** module chunks = 0
 **/